module.exports = new __parcel__URL__("edit-shortcuts.f0152ee6.png").toString();